import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { api } from '../../services/api';
import SweetAlert from 'react-bootstrap-sweetalert';
import InputMask from 'react-input-mask';
import Menu from '../../comum/Menu/menu.jsx';
import Footer from '../../comum/Footer';
import './index.css';
import Swal from 'sweetalert2';
import {
  FaUserClock,
  FaBuilding,
  FaStore,
  FaCommentDots,
  FaUser,
  FaWhatsapp,
  FaSitemap,
  FaCheckCircle,
  FaTicketAlt,
  FaBell
} from 'react-icons/fa';

const SETORES_PADRAO = [
  'COMERCIAL',
  'CONTABILIDADE',
  'FINANCEIRO',
  'JURIDICO',
  'PSCICOLOGA',
  'RECURSOS HUMANOS',
  'TI'
];

function AtendimentoForm() {
  const { loja } = useParams();

  const [locais, setLocais] = useState([]);
  const [localSelecionado, setLocalSelecionado] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const [mostrarFormulario, setMostrarFormulario] = useState(false);
  const [codLoja, setCodLoja] = useState(null);

  const [nome, setNome] = useState('');
  const [nomePessoa, setNomePessoa] = useState('');
  const [whatsapp, setWhatsapp] = useState('');
  const [descricao, setDescricao] = useState('');
  const [empresa, setEmpresa] = useState('');
  const [setorSelecionado, setSetorSelecionado] = useState('');

  const [maskTelefone] = useState('(99) 99999-9999');

  const [erro, setErro] = useState('');
  const [sucesso, setSucesso] = useState('');
  const [senhaInfo, setSenhaInfo] = useState(null);

  const [carregando, setCarregando] = useState(true);
  const [carregandoPosicao, setCarregandoPosicao] = useState(false);
  const [enviando, setEnviando] = useState(false);

  const intervaloRef = useRef(null);
  const audioAlarmeRef = useRef(null);
  const audioVozRef = useRef(null);
  const audioContextRef = useRef(null);
  const loopVozTimerRef = useRef(null);
  const tituloOriginalRef = useRef(document.title);
  const estaChamandoRef = useRef(false);

  // =========================
  // SOLICITAÇÃO DE PERMISSÃO DE NOTIFICAÇÃO
  // =========================
  useEffect(() => {
    if ('Notification' in window && Notification.permission === 'default') {
      Notification.requestPermission();
    }
  }, []);

  // =========================
  // INICIALIZAÇÃO E DESBLOQUEIO DE ÁUDIO UNIVERSAL (iOS/ANDROID/DESKTOP)
  // =========================
  useEffect(() => {
    // Instancia o player de alarme
    audioAlarmeRef.current = new Audio('/alarme.mp3');
    audioAlarmeRef.current.loop = true;
    audioAlarmeRef.current.volume = 1;

    // Instancia o player de voz
    audioVozRef.current = new Audio();
    audioVozRef.current.volume = 1;

    const desbloquearAudioUniversal = () => {
      // 1. Desbloqueia Web Audio Context (Exigência iOS/WebKit)
      try {
        const AudioCtx = window.AudioContext || window.webkitAudioContext;
        if (AudioCtx) {
          if (!audioContextRef.current) {
            audioContextRef.current = new AudioCtx();
          }
          if (audioContextRef.current.state === 'suspended') {
            audioContextRef.current.resume();
          }
        }
      } catch (e) {
        console.log('Web Audio Context não suportado:', e);
      }

      // 2. Desbloqueia HTML5 Audio Elements sem emitir som
      if (audioAlarmeRef.current) {
        audioAlarmeRef.current.play().then(() => {
          audioAlarmeRef.current.pause();
          audioAlarmeRef.current.currentTime = 0;
        }).catch(() => {});
      }

      if (audioVozRef.current) {
        audioVozRef.current.play().then(() => {
          audioVozRef.current.pause();
          audioVozRef.current.currentTime = 0;
        }).catch(() => {});
      }

      document.removeEventListener('touchstart', desbloquearAudioUniversal);
      document.removeEventListener('click', desbloquearAudioUniversal);
    };

    document.addEventListener('touchstart', desbloquearAudioUniversal, { passive: true });
    document.addEventListener('click', desbloquearAudioUniversal);

    return () => {
      document.removeEventListener('touchstart', desbloquearAudioUniversal);
      document.removeEventListener('click', desbloquearAudioUniversal);
    };
  }, []);

  // =========================
  // LOCAL STORAGE
  // =========================
  const salvarFilaLocal = (dados) => {
    const dadosComData = {
      ...dados,
      dataCriacao: new Date().toLocaleDateString('pt-BR')
    };
    localStorage.setItem('fila_atendimento', JSON.stringify(dadosComData));
  };

  const limparFilaLocal = () => {
    localStorage.removeItem('fila_atendimento');
  };

  // =========================
  // WAKE LOCK (MANTÉM TELA LIGADA)
  // =========================
  useEffect(() => {
    let wakeLock = null;

    const solicitarWakeLock = async () => {
      try {
        if ('wakeLock' in navigator && senhaInfo?.senha) {
          wakeLock = await navigator.wakeLock.request('screen');
        }
      } catch (err) {
        console.log('Wake lock indisponível:', err.message);
      }
    };

    solicitarWakeLock();

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        solicitarWakeLock();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      if (wakeLock !== null) {
        wakeLock.release().catch(() => { });
      }
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [senhaInfo?.senha]);

  // =========================
  // RESTAURA FILA EXISTENTE
  // =========================
  useEffect(() => {
    const filaSalva = localStorage.getItem('fila_atendimento');

    if (filaSalva) {
      try {
        const dados = JSON.parse(filaSalva);
        const hoje = new Date().toLocaleDateString('pt-BR');

        if (dados.dataCriacao && dados.dataCriacao !== hoje) {
          limparFilaLocal();
          return;
        }

        setSenhaInfo(dados);
        setCodLoja(dados.cli_loja);
        setLocalSelecionado(dados.cli_local);
        setShowPopup(false);
        setMostrarFormulario(false);
      } catch (e) {
        localStorage.removeItem('fila_atendimento');
      }
    }
  }, []);

  // =========================
  // CARREGA INFORMAÇÕES DA LOJA
  // =========================
  useEffect(() => {
    const filaSalva = localStorage.getItem('fila_atendimento');

    api.get(`/atendimento/loja/${loja}`)
      .then(res => {
        setLocais(res.data);
        if (res.data.length > 0) {
          if (!filaSalva) {
            setLocalSelecionado(res.data[0].atend_local);
            setCodLoja(res.data[0].atend_loja);

            if (res.data[0].atend_loja !== 1) {
              setShowPopup(true);
            } else {
              setMostrarFormulario(true);
            }
          }
        }
      })
      .catch(() => {
        setErro('Loja não encontrada!');
      })
      .finally(() => {
        setCarregando(false);
      });
  }, [loja]);

  // =========================
  // ATUALIZA POSIÇÃO DA FILA
  // =========================
  useEffect(() => {
    if (!senhaInfo?.senha || !codLoja || !localSelecionado) return;

    intervaloRef.current = setInterval(async () => {
      try {
        setCarregandoPosicao(true);
        const res = await api.get('/atendimento/fila/posicao', {
          params: {
            cli_loja: codLoja,
            cli_local: localSelecionado,
            cli_senha: senhaInfo.senha
          }
        });

        const novaPosicao = res.data.posicao ?? res.data.Posicao ?? 0;

        setSenhaInfo(prev => {
          const atualizado = { ...prev, posicao: novaPosicao };
          salvarFilaLocal(atualizado);
          return atualizado;
        });

        if (novaPosicao === 0) {
          clearInterval(intervaloRef.current);
          intervaloRef.current = null;
        }
      } catch {
        console.log('Erro ao atualizar posição na fila');
      } finally {
        setCarregandoPosicao(false);
      }
    }, 20000);

    return () => clearInterval(intervaloRef.current);
  }, [senhaInfo?.senha, codLoja, localSelecionado]);

  // =========================
  // LIMPEZA AUTOMÁTICA DE ERROS
  // =========================
  useEffect(() => {
    if (erro) {
      const timer = setTimeout(() => setErro(''), 5000);
      return () => clearTimeout(timer);
    }
  }, [erro]);

  const onlyNumbers = (str) => str.replace(/\D/g, '');

  const limparCampos = () => {
    setNome('');
    setWhatsapp('');
    setDescricao('');
    setEmpresa('');
    setSetorSelecionado('');
    setNomePessoa('');
  };

  // =========================
  // REPRODUÇÃO ININTERRUPTA DE ÁUDIO (ALARME + VOZ DO SERVIDOR)
  // =========================
  useEffect(() => {
    const tocarLoopVozIninterrupto = (senhaAtual) => {
      if (!estaChamandoRef.current || !audioVozRef.current) return;

      const urlAudio = `${api.defaults.baseURL}/atendimento/audio?senha=${senhaAtual}&t=${Date.now()}`;
      audioVozRef.current.src = urlAudio;

      // Evento disparado quando o áudio termina: re-agenda sem interrupção
      audioVozRef.current.onended = () => {
        if (estaChamandoRef.current) {
          loopVozTimerRef.current = setTimeout(() => {
            tocarLoopVozIninterrupto(senhaAtual);
          }, 1200);
        }
      };

      audioVozRef.current.onerror = () => {
        if (estaChamandoRef.current) {
          loopVozTimerRef.current = setTimeout(() => {
            tocarLoopVozIninterrupto(senhaAtual);
          }, 2000);
        }
      };

      const playPromise = audioVozRef.current.play();
      if (playPromise !== undefined) {
        playPromise.catch((err) => {
          console.log('Tentando reproduzir voz novamente:', err);
          if (estaChamandoRef.current) {
            loopVozTimerRef.current = setTimeout(() => {
              tocarLoopVozIninterrupto(senhaAtual);
            }, 1500);
          }
        });
      }
    };

    const interval = setInterval(async () => {
      if (!senhaInfo?.senha || estaChamandoRef.current) return;

      try {
        const res = await api.get('/atendimento/chamada', {
          params: {
            cli_loja: codLoja,
            cli_senha: senhaInfo.senha,
            cli_local: localSelecionado
          }
        });

        if (res.data.length > 0) {
          const chamada = res.data[0];
          estaChamandoRef.current = true;

          // 1. Título Piscante na Aba do Navegador
          let flagTitulo = false;
          const intervalTitulo = setInterval(() => {
            document.title = flagTitulo ? '🔔 SUA SENHA FOI CHAMADA!' : '⚠️ COMPAREÇA AO ATENDIMENTO';
            flagTitulo = !flagTitulo;
          }, 800);

          // 2. Notificação Nativa do Sistema Operacional
          try {
            if ('Notification' in window && Notification.permission === 'granted') {
              new Notification('🔔 VOCÊ ESTÁ SENDO CHAMADO!', {
                body: chamada.cli_chamada,
                icon: '/Images/icone-app.png',
                vibrate: [1000, 500, 1000, 500, 1000],
                requireInteraction: true,
                tag: 'chamada-atendimento'
              });
            }
          } catch (e) { }

          // 3. Tocar Alarme em Loop Infinito e Ininterrupto
          let reforcoAlarme = null;
          try {
            if (audioAlarmeRef.current) {
              audioAlarmeRef.current.currentTime = 0;
              audioAlarmeRef.current.loop = true;
              audioAlarmeRef.current.play().catch(() => {});

              // Monitor contínuo: reativa se o SO ou o navegador pausar
              reforcoAlarme = setInterval(() => {
                if (audioAlarmeRef.current && audioAlarmeRef.current.paused && estaChamandoRef.current) {
                  audioAlarmeRef.current.play().catch(() => {});
                }
              }, 1000);
            }
          } catch (e) { }

          // 4. Vibração Contínua do Dispositivo
          let intervalVibracao = null;
          try {
            if ('vibrate' in navigator) {
              navigator.vibrate([1000, 300, 1000, 300, 1000]);
              intervalVibracao = setInterval(() => {
                navigator.vibrate([1000, 300, 1000, 300, 1000]);
              }, 3000);
            }
          } catch (e) { }

          // 5. Executa a reprodução do áudio de voz retornado pelo backend
          tocarLoopVozIninterrupto(senhaInfo.senha);

          // 6. Modal Interativo de Confirmação
          await Swal.fire({
            icon: 'warning',
            title: '<span style="color:#8b0000; font-weight:800; font-size:1.4rem;">VOCÊ ESTÁ SENDO CHAMADO!</span>',
            html: `
              <div style="background-color: #f8fafc; border: 2px solid #fca5a5; border-radius: 16px; padding: 18px; margin-top: 10px;">
                <div style="font-size: 1.8rem; font-weight: 900; color: #8b0000; margin-bottom: 8px;">
                  Senha #${senhaInfo.senha}
                </div>
                <div style="font-size: 1.1rem; font-weight: 600; color: #0f172a; line-height: 1.5;">
                  ${chamada.cli_chamada}
                </div>
              </div>
            `,
            confirmButtonText: 'ENTENDIDO, ESTOU A CAMINHO!',
            confirmButtonColor: '#8b0000',
            allowOutsideClick: false,
            allowEscapeKey: false,
            customClass: { popup: 'rounded-4 shadow-lg' }
          });

          // Encerra todos os loops sonoros ao clicar em OK
          estaChamandoRef.current = false;
          clearInterval(intervalTitulo);
          if (intervalVibracao) clearInterval(intervalVibracao);
          if (reforcoAlarme) clearInterval(reforcoAlarme);
          if (loopVozTimerRef.current) clearTimeout(loopVozTimerRef.current);

          document.title = tituloOriginalRef.current;

          try {
            if (audioAlarmeRef.current) {
              audioAlarmeRef.current.pause();
              audioAlarmeRef.current.currentTime = 0;
            }
            if (audioVozRef.current) {
              audioVozRef.current.pause();
              audioVozRef.current.currentTime = 0;
            }
          } catch { }

          await api.put('/atendimento/notificado', {
            cli_loja: codLoja,
            cli_senha: senhaInfo.senha,
            cli_local: localSelecionado
          });

          limparFilaLocal();
          setSenhaInfo(null);
          setShowPopup(false);
          setMostrarFormulario(false);
        }
      } catch (err) {
        console.log('Erro na verificação de chamada:', err);
      }
    }, 4000);

    return () => {
      estaChamandoRef.current = false;
      clearInterval(interval);
      if (loopVozTimerRef.current) clearTimeout(loopVozTimerRef.current);
      try {
        if (audioAlarmeRef.current) {
          audioAlarmeRef.current.pause();
          audioAlarmeRef.current.currentTime = 0;
        }
        if (audioVozRef.current) {
          audioVozRef.current.pause();
          audioVozRef.current.currentTime = 0;
        }
      } catch { }
    };
  }, [senhaInfo, codLoja, localSelecionado]);

  // =========================
  // ENVIAR SOLICITAÇÃO DE ATENDIMENTO
  // =========================
  const enviarAtendimento = async () => {
    if (enviando) return;

    if (
      !nome.trim() ||
      !onlyNumbers(whatsapp) ||
      !descricao.trim() ||
      !codLoja ||
      (codLoja === 1 && !setorSelecionado) ||
      (codLoja === 1 && !nomePessoa.trim())
    ) {
      setErro('Preencha todos os campos obrigatórios corretamente.');
      return;
    }

    setEnviando(true);

    const setorConcatenado =
      codLoja === 1
        ? `${setorSelecionado} - ${nomePessoa.trim()}`
        : setorSelecionado;

    const payload = {
      cli_loja: codLoja.toString(),
      cli_local: localSelecionado,
      cli_status: 'I',
      cli_tipo: codLoja === 1 ? 'A' : 'S',
      cli_nome: nome.trim(),
      cli_whatsapp: onlyNumbers(whatsapp),
      cli_descricao: descricao.trim(),
      cli_empresa: empresa.trim(),
      ...(codLoja === 1 && { cli_setor: setorConcatenado })
    };

    try {
      const res = await api.post('/atendimento/fila', payload);

      const dadosFila = {
        ...res.data[0],
        cli_loja: codLoja,
        cli_local: localSelecionado
      };

      setSenhaInfo(dadosFila);
      salvarFilaLocal(dadosFila);
      limparCampos();

      setMostrarFormulario(false);
      setShowPopup(false);
      setSucesso('Solicitação enviada com sucesso! Sua senha é: ' + res.data[0].senha);

      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (err) {
      setErro('Erro ao enviar atendimento. Tente novamente.');
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="atendimento-form-wrapper">
      <Menu modulo="Atendimento" />

      <main className="container-fluid pagina-dados max-width-atendimento">
        <div className="row justify-content-center">
          <div className="col-12 col-md-10 col-lg-7">
            {carregando ? (
              <div className="text-center py-5">
                <div className="spinner-border spinner-border-lg text-danger" role="status" style={{ color: '#8b0000' }}></div>
                <p className="mt-3 text-muted fw-semibold">Buscando informações da loja...</p>
              </div>
            ) : (
              <>
                {!senhaInfo && showPopup && !mostrarFormulario && (
                  <div className="card border-0 shadow-sm rounded-4 overflow-hidden my-4 bg-white">
                    <div className="card-header bg-custom-red text-white p-3 text-center border-0">
                      <h5 className="m-0 fw-bold d-flex align-items-center justify-content-center gap-2">
                        <FaUserClock /> Escolha o Atendimento
                      </h5>
                    </div>
                    <div className="card-body p-4">
                      <div className="mb-3 text-center">
                        <span className="text-muted small">Local de Atendimento:</span>
                        <h6 className="fw-bold text-dark m-0 mt-1">{localSelecionado}</h6>
                      </div>

                      {locais.length > 1 && (
                        <div className="mb-4">
                          <label className="form-label small fw-bold text-secondary">
                            Alterar Local:
                          </label>
                          <select
                            className="form-select form-select-lg rounded-3"
                            value={localSelecionado}
                            onChange={(e) => setLocalSelecionado(e.target.value)}
                          >
                            {locais.map((l, i) => (
                              <option key={i} value={l.atend_local}>
                                {l.atend_local}
                              </option>
                            ))}
                          </select>
                        </div>
                      )}

                      <button
                        className="btn btn-danger-custom w-100 py-3 rounded-3 fw-bold d-flex align-items-center justify-content-center gap-2"
                        onClick={() => {
                          setMostrarFormulario(true);
                          setShowPopup(false);
                        }}
                      >
                        <FaStore /> Separação de Produtos
                      </button>
                    </div>
                  </div>
                )}

                {!senhaInfo && mostrarFormulario && (
                  <div className="card border-0 shadow-sm rounded-4 overflow-hidden my-3 bg-white">
                    <div className="card-header bg-custom-red text-white p-3 border-0">
                      <h5 className="m-0 fw-bold d-flex align-items-center gap-2 fs-6">
                        <FaTicketAlt /> Retirar Senha de Atendimento
                      </h5>
                      <span className="small text-white-50">Preencha os dados abaixo para entrar na fila</span>
                    </div>

                    <div className="card-body p-4">
                      <div className="row g-3">
                        <div className="col-12 col-md-6">
                          <label className="form-label small fw-bold text-secondary d-flex align-items-center gap-1">
                            <FaUser className="text-danger" /> Nome Completo *
                          </label>
                          <input
                            className="form-control rounded-3"
                            type="text"
                            value={nome}
                            onChange={(e) => setNome(e.target.value)}
                            placeholder="Digite seu nome completo"
                            maxLength={50}
                          />
                        </div>

                        <div className="col-12 col-md-6">
                          <label className="form-label small fw-bold text-secondary d-flex align-items-center gap-1">
                            <FaWhatsapp className="text-success" /> WhatsApp *
                          </label>
                          <InputMask
                            className="form-control rounded-3"
                            mask={maskTelefone}
                            value={whatsapp}
                            onChange={(e) => setWhatsapp(e.target.value)}
                            placeholder="(99) 99999-9999"
                          />
                        </div>

                        {codLoja === 1 && (
                          <>
                            <div className="col-12">
                              <label className="form-label small fw-bold text-secondary d-flex align-items-center gap-1">
                                <FaBuilding className="text-primary" /> Empresa / Representação
                              </label>
                              <input
                                className="form-control rounded-3"
                                type="text"
                                value={empresa}
                                onChange={(e) => setEmpresa(e.target.value)}
                                placeholder="Informe o nome da sua empresa (opcional)"
                                maxLength={30}
                              />
                            </div>

                            <div className="col-12">
                              <label className="form-label small fw-bold text-secondary d-flex align-items-center gap-1 mb-2">
                                <FaSitemap className="text-warning" /> Selecione o Setor *
                              </label>

                              <div className="setor-grid">
                                {SETORES_PADRAO.map((setor, index) => (
                                  <label
                                    key={index}
                                    className={`setor-card-item ${setorSelecionado === setor ? 'active' : ''}`}
                                  >
                                    <input
                                      type="radio"
                                      name="setor"
                                      value={setor}
                                      checked={setorSelecionado === setor}
                                      onChange={() => setSetorSelecionado(setor)}
                                      className="d-none"
                                    />
                                    <span>{setor}</span>
                                  </label>
                                ))}
                              </div>
                            </div>

                            {setorSelecionado && (
                              <div className="col-12 mt-3 bg-light p-3 rounded-3 border">
                                <label className="form-label small fw-bold text-dark d-flex align-items-center gap-1">
                                  <FaUser className="text-danger" /> Com quem deseja falar no setor {setorSelecionado}? *
                                </label>
                                <input
                                  className="form-control rounded-3"
                                  type="text"
                                  value={nomePessoa}
                                  onChange={(e) => setNomePessoa(e.target.value)}
                                  placeholder="Digite o nome da pessoa"
                                  maxLength={50}
                                />
                              </div>
                            )}
                          </>
                        )}

                        <div className="col-12">
                          <label className="form-label small fw-bold text-secondary d-flex align-items-center gap-1">
                            <FaCommentDots className="text-info" /> {codLoja === 1 ? 'Assunto / Descrição *' : 'Pedido / Produtos Desejados *'}
                          </label>
                          <textarea
                            className="form-control rounded-3"
                            rows={3}
                            value={descricao}
                            onChange={(e) => setDescricao(e.target.value)}
                            placeholder={codLoja === 1 ? 'Descreva o assunto do seu atendimento' : 'Informe os códigos ou produtos que deseja solicitar'}
                          />
                        </div>

                        <div className="col-12 mt-4">
                          <button
                            className="btn btn-danger-custom w-100 py-3 rounded-3 fw-bold d-flex align-items-center justify-content-center gap-2"
                            onClick={enviarAtendimento}
                            disabled={enviando}
                          >
                            {enviando ? (
                              <>
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Solicitando Senha...
                              </>
                            ) : (
                              <>
                                <FaCheckCircle /> Retirar Senha de Atendimento
                              </>
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {senhaInfo && (
                  <div className="card border-0 shadow-sm rounded-4 overflow-hidden my-4 bg-white text-center p-4">
                    <div className="senha-badge-box mb-3 mx-auto">
                      <span className="small text-muted fw-bold text-uppercase d-block">Sua Senha</span>
                      <h1 className="display-4 fw-black text-danger m-0">#{senhaInfo.senha}</h1>
                    </div>

                    <div className="posicao-status-box p-3 rounded-3 bg-light border my-2">
                      {carregandoPosicao && (
                        <div className="d-flex align-items-center justify-content-center gap-2 text-muted mb-2">
                          <div className="spinner-border spinner-border-sm text-danger" role="status"></div>
                          <span className="small">Atualizando posição...</span>
                        </div>
                      )}

                      {senhaInfo.posicao !== undefined && (
                        senhaInfo.posicao === 1 ? (
                          <div className="posicao-animada text-success fw-bold fs-4">
                            🎉 VOCÊ É O PRÓXIMO DA FILA!
                          </div>
                        ) : (
                          <div className="posicao-animada text-dark fw-bold fs-5">
                            Sua Posição na Fila: <span className="text-danger fw-black">{senhaInfo.posicao}º</span>
                          </div>
                        )
                      )}
                    </div>

                    <div className="alert alert-warning border-warning rounded-3 mt-3 mb-0 text-start small d-flex align-items-center gap-2">
                      <FaBell className="fs-4 text-warning flex-shrink-0" />
                      <div>
                        <strong>Mantenha esta página aberta!</strong> <br />
                        Avisaremos na tela, com som e vibração no momento em que você for chamado.
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </main>

      {erro && (
        <SweetAlert danger title="Atenção" onConfirm={() => setErro('')}>
          {erro}
        </SweetAlert>
      )}

      {sucesso && (
        <SweetAlert success title="Senha Gerada!" onConfirm={() => setSucesso('')}>
          {sucesso}
        </SweetAlert>
      )}

      <Footer />
    </div>
  );
}

export default AtendimentoForm;